<template>
  <div id="root_container">
    <router-view v-if="isAuthenticated && isLogoLoaded"></router-view>
    <toaster></toaster>
  </div>
</template>

<script>
import { DEFAULT_ACCOUNT_LOGO, DEFAULT_ACCOUNT_NAME, ROUTES } from "./utils/constants";
import { isCustomDomain, updateFaviconAndTitle } from "./utils/helpers";
import toaster from "./components/global/toaster.vue";

const { ONBOARDING, OVERVIEW, JOB_DETAILS } = ROUTES;

export default {
  name: "app",
  components: { toaster },
  data() {
    return {
      isAuthenticated: false,
      isLogoLoaded: false,
      authRoutes: [
        "/proof-item",
        "/proof-details",
        "/overview",
        "/dashboard",
        "/contact-archive",
        "/approver-item",
        "/automation-archive",
        "/workflows",
        "/email-templates",
        "/checklists",
        "/template-item",
        "/workflow-item",
        "/proof-archive",
        "/create",
        "/profile",
        "/onboarding",
        "/jobs",
        "/job-details/:id",
        "/job-status",
        "/artwork-intake",
        "/artwork-intake/submission/:id",
        "/artwork-intake/settings",
        "/knowledge-base",
        "/knowledge-base-article"
      ],
      adminRoutes: ["/account", "/billing", "/users"],
      superAdminRoutePrefix: "/captains-deck",
      isCustomDomain
    };
  },
  beforeMount: function(){
    this.$A.MarketingService.CaptureAttribution();
    this.authCheck();
  },
  mounted: async function () {
    $(function () {
      $('[data-toggle="tooltip"]').tooltip();
    });

    let accountLogo = null;
    let accountTitle = null;
    if (this.isCustomDomain) {
      const domainInfo = await $A.UserService.GetDomainInfo(window.location.hostname);
      accountLogo = _.get(domainInfo, "url", DEFAULT_ACCOUNT_LOGO);
      accountTitle = _.get(domainInfo, "accountName", DEFAULT_ACCOUNT_NAME);
    } else {
      accountLogo = _.get(this, '$A.Auth.account.whiteLabelLogoUri', DEFAULT_ACCOUNT_LOGO);
      accountTitle = _.get(this, '$A.Auth.account.name', DEFAULT_ACCOUNT_NAME);
    }
    if (!accountLogo) accountLogo = DEFAULT_ACCOUNT_LOGO;
    if (!accountTitle) accountTitle = DEFAULT_ACCOUNT_NAME;
    this.updateFaviconAndTitle({ accountLogo, accountTitle });

    this.isLogoLoaded = true;

    if (this.$A.Auth) {
      this.$A.MarketingService.SSOPostLoginAttributionCheck(
          this.$A.Auth.name,
          this.$A.Auth.account.name,
          this.$A.Auth.email,
          this.$A.Auth.title,
          this.$A.Auth.phone,
      );
    }
  },
  methods: {
    async loadUserData(){
      const currentUser = await this.$A.UserService.GetUser();
      console.log('Loading User Data, as onboardedAt doesnt exists', currentUser);
      this.$A.UpdateUserObjectAndBustCache(currentUser);
    },
    authCheck: async function () {
      const urlSearchParams = new URLSearchParams(window.location.search);
      const params = Object.fromEntries(urlSearchParams.entries());

      let currentUser = this.$A.Auth;
      
      if (currentUser && !currentUser.hasOwnProperty('onboardedAt')) {
        await this.loadUserData();
        // Refresh currentUser with updated data after loading from server
        currentUser = this.$A.Auth;
      }

      let path = this.$route.path;
      const currentPath = window.location.pathname;
      let query = this.$route.query;

      if (currentUser && !currentUser.onboardedAt && currentPath !== ONBOARDING) {
        this.isAuthenticated = true;
        this.$router.push(ONBOARDING);
        return;
      }

      if (currentUser && currentUser.onboardedAt && currentPath === ONBOARDING) {
        window.location.href = OVERVIEW;
        this.isAuthenticated = true;
        return;
      }

      if(!currentUser && currentPath === ONBOARDING){
        window.open('/');
      }


      let needsSecurity = false;
      for (let i = 0; i < this.authRoutes.length; i++) {
        let r = this.authRoutes[i];
        if (path === r) {
          needsSecurity = true;
        }
      }

      this.$A.CheckIfShouldNavigateToView();
      if(params.tl){
        let ld = atob(params.tl);
        //log them in with their temp token
        let token = ld.replace("\n","")
        await $A.UserService.LoginWithToken(token, true);
        currentUser = this.$A.Auth
      }
      if (params.g !== undefined && currentUser !== null) {
        let linkdata = atob(params.g).split(",");
          if (
              linkdata.length === 2 &&
              linkdata[0] === "proof-item" &&
              linkdata[1] > 0
          ) {
            let self = this;
            sessionStorage.viewToViewData = JSON.stringify({
              proof: { id: parseInt(linkdata[1]) },
            });
            window.location = "/" + linkdata[0];
            this.isAuthenticated = true;
            return;
          }
          if (
              linkdata.length === 2 &&
              linkdata[0] === JOB_DETAILS.replace("/","") &&
              linkdata[1] > 0
          ) {
            let self = this;
            window.location = `${JOB_DETAILS}/` + linkdata[1];
            this.isAuthenticated = true;
            return;
          }
          if (
              linkdata.length === 3 &&
              linkdata[0] === "review-page" &&
              linkdata[2] > 0
          ) {
            let self = this;
            sessionStorage.viewToViewData = JSON.stringify({
              proof: { id: parseInt(linkdata[2]) },
            });
            window.location = "/review/" + linkdata[1];
            this.isAuthenticated = true;
            return;
          }
      }

      if (window.location &&
          window.location.href &&
          !window.location.href.includes('/review') && currentUser !== null) {
        //if this call fails the user will be logged out.
        let auth = await this.$A.AccountService.Get();
        // window.location = "/overview";
        // this.$router.push("/overview");
        this.isAuthenticated = true;
        // return;
      }



      if (currentUser == null) {
        this.isAuthenticated = true;
        return;
      }

      //check to see if a sub user is trying to access an admin page if so redirect to overview
      if (!currentUser.permissions.manageAccount) {
        for (let i = 0; i < this.adminRoutes.length; i++) {
          let ar = this.adminRoutes[i];
          if (path === ar) {
            window.location = "/403";
            this.isAuthenticated = true;
            return;
          }
        }
      }
      //check to see if a sub user is trying to access an admin page if so redirect to overview
      if (!currentUser.permissions.role || currentUser.permissions.role.roleId !== 3) {
        if (currentPath.startsWith(this.superAdminRoutePrefix)) {
          window.location = "/403";
          this.isAuthenticated = true;
          return;
        }
      }
      this.isAuthenticated = true;
    },
    updateFaviconAndTitle
  },
};
</script>
<style>
#root_container {
}
</style>
